import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import type { components } from "@/api/schema";

type DiffSummary = components["schemas"]["InventoryDiffSummary"];

interface DiffFreshnessProps {
  summary: DiffSummary;
}

/**
 * "source: Sino shelf-count <time> (request <id>)" — spec D5. The request id
 * is the sino_update_stock_requests row, so an operator questioning a number
 * can go find the raw payload that produced it instead of guessing.
 */
export function DiffFreshness({ summary }: DiffFreshnessProps): JSX.Element | null {
  const { t, i18n } = useTranslation("inventory_diff");
  if (!summary.snapshot_at) return null;

  const time = new Date(summary.snapshot_at).toLocaleString(i18n.language, {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <p
      data-testid="diff-freshness"
      className="mb-[var(--sp-3)] text-[12.5px] text-[var(--text-subtle)]"
    >
      {t("freshness.source_request", {
        source: summary.source,
        time,
        id: summary.run_id,
      })}
    </p>
  );
}
